import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiCall } from '../utils/api.js'

/**
 * Costo IA per processo, tenuto come mappa a parte e NON come campo dentro gli oggetti progetto.
 *
 * Tre motivi, tutti concreti: `loadProjects` sostituisce l'array dei processi ad ogni ricarica e ad
 * ogni polling, quindi un campo iniettato verrebbe cancellato e andrebbe rifuso ogni volta;
 * Dashboard e Archivio leggono lo stesso array e non lo vogliono; e ProjectHistory confronta le
 * chiavi del processo per mostrare le modifiche, quindi un campo non persistito comparirebbe come
 * una modifica fantasma in ogni confronto.
 */
export const useAiCostStore = defineStore('aiCost', () => {
  // idProject -> { costUsd, runs, unpricedRuns, legacyRuns }
  const byProject = ref({})
  const totalCostUsd = ref(0)
  const loading = ref(false)
  const loaded = ref(false)

  async function loadCosts() {
    loading.value = true
    try {
      const data = await apiCall('/api/billing/usage/by-project', { method: 'GET' })
      const map = {}
      for (const row of data?.items || []) map[row.idProject] = row
      byProject.value = map
      totalCostUsd.value = data?.totalCostUsd || 0
      loaded.value = true
    } catch (e) {
      // Il costo è informativo: se non arriva, la colonna mostra un trattino e la tabella funziona
      // lo stesso. Un errore qui non deve impedire di lavorare sui processi.
      console.warn('Costo IA per processo non disponibile:', e?.message || e)
    } finally {
      loading.value = false
    }
  }

  /** Costo di un processo, o null se non ha mai consumato nulla. */
  function costOf(idProject) {
    const row = byProject.value[idProject]
    return row ? row.costUsd : null
  }

  function rowOf(idProject) {
    return byProject.value[idProject] || null
  }

  return { byProject, totalCostUsd, loading, loaded, loadCosts, costOf, rowOf }
})
